import axios from "axios";
import { getToken } from "../../common/HandleAuth";

const baseURL = process.env.VUE_APP_API;

// Crear instancia de axios
const Service = axios.create({ baseURL });

// Interceptor para agregar el token dinámicamente en cada petición
Service.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default Service;
